import React from "react";

// Ported from plugin customComponent/noSurprisePopupContent.jsx
// "Guaranteed Flat Rate" — the body of the perk's popup (desktop) and of the
// `noSurprises` step (mobile). One sentence by design: the perk card already carries
// the headline ("No Surge. No KM or Minute Charges"), this spells it out.
export function NoSurprisePopupContent() {
    return (
        <p className="hopn-flat-rate-note">
            The price you see is the price you pay — no surge pricing, no per-km or
            per-minute fees.
        </p>
    );
}

export default NoSurprisePopupContent;
